<template>
  <layout title="Tenants">
    <div class="row">
      <div class="col-10">
        <h2 class="page-heading">
          <inertia-link
            class="previous-path-header"
            :href="route('users.index')"
          >
            Users
          </inertia-link>
          / {{ form.first_name }} {{ form.last_name }}
        </h2>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card shadow-sm p-3 mb-5 bg-white rounded mt-2">
          <div class="card-body col-md-8">
            <nav>
              <div  v-if="classrooms.length > 0" class="nav nav-tabs mb-4" id="nav-tab" role="tablist">
                <a
                  class="nav-item nav-link active"
                  id="nav-details-tab"
                  data-toggle="tab"
                  href="#nav-details"
                  role="tab"
                  aria-controls="nav-details"
                  aria-selected="true"
                >
                  Edit
                </a>
                <a
                  class="nav-item nav-link"
                  id="nav-classrooms-tab"
                  data-toggle="tab"
                  href="#nav-classrooms"
                  role="tab"
                  aria-controls="nav-classrooms"
                  aria-selected="false"
                >
                  Classrooms
                  <span class="badge badge-secondary">
                    {{ classrooms.length }}
                  </span>
                </a>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <div
                class="tab-pane fade show active"
                id="nav-details"
                role="tabpanel"
                aria-labelledby="nav-details-tab"
              >
                <form @submit.prevent="update">
                  <h4>Personal Details</h4>
                  <hr />

                  <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">
                      First Name
                    </label>
                    <div class="col-sm-10">
                      <input
                        type="text"
                        class="form-control"
                        id="first_name"
                        v-model="form.first_name"
                      />
                      <div
                        v-if="errors && errors.first_name"
                        class="d-block invalid-feedback"
                      >
                        {{ errors.first_name }}
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">
                      Last Name
                    </label>
                    <div class="col-sm-10">
                      <input
                        type="text"
                        class="form-control"
                        id="last_name"
                        v-model="form.last_name"
                      />
                      <div
                        v-if="errors && errors.last_name"
                        class="d-block invalid-feedback"
                      >
                        {{ errors.last_name }}
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">
                      Email
                    </label>
                    <div class="col-sm-10">
                      <input
                        type="text"
                        class="form-control"
                        id="email"
                        v-model="form.email"
                      />
                      <div
                        v-if="errors && errors.email"
                        class="d-block invalid-feedback"
                      >
                        {{ errors.email }}
                      </div>
                    </div>
                  </div>
                                <div class="form-group row">
                <label for="name" class="col-sm-2 col-form-label">
                  Student ID
                </label>
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    id="student_reg_id"
                    v-model="form.student_reg_id"
                  />
                  <div
                    v-if="errors && errors.student_reg_id"
                    class="d-block invalid-feedback"
                  >
                    {{ errors.student_reg_id }}
                  </div>
                </div>
              </div>
                  <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">
                      Timezone
                    </label>
                    <div
                      class="col-sm-10"
                      style="padding-top: 7px; padding-left: 28px"
                    >
                      {{ form.timezone }}
                    </div>
                  </div>

                  <h4 class="mt-5">User Account</h4>
                  <hr />
                  <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">
                      Username
                    </label>
                    <div class="col-sm-10">
                      <input
                        type="text"
                        class="form-control"
                        id="last_name"
                        v-model="form.username"
                      />
                      <div
                        v-if="errors && errors.username"
                        class="d-block invalid-feedback"
                      >
                        {{ errors.username }}
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">
                      Password
                    </label>
                    <div class="col-sm-10">
                      <input
                        type="password"
                        class="form-control"
                        id="password"
                        v-model="form.password"
                      />
                      <div
                        v-if="errors && errors.password"
                        class="d-block invalid-feedback"
                      >
                        {{ errors.password }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">
                      Confirm Password
                    </label>
                    <div class="col-sm-10">
                      <input
                        type="password"
                        class="form-control"
                        id="password_confirmation"
                        v-model="form.password_confirmation"
                      />
                      <div
                        v-if="errors && errors.password_confirmation"
                        class="d-block invalid-feedback"
                      >
                        {{ errors.password_confirmation }}
                      </div>
                    </div>
                  </div>

                  <h4 class="mt-5">Roles and Permission</h4>
                  <hr />

                  <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">
                      Role(s)
                    </label>
                    <div class="col-sm-10">
                      <select
                        multiple
                        class="form-control"
                        v-model="form.roles"
                      >
                        <option
                          v-for="role in roles"
                          :key="role.id"
                          :value="role.id"
                          :selected="form.roles.includes(role.id)"
                        >
                          {{ role.name }}
                        </option>
                      </select>
                      <div
                        v-if="errors && errors.roles"
                        class="d-block invalid-feedback"
                      >
                        {{ errors.roles }}
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="col-sm-12">
                      <button type="submit" class="btn btn-primary float-right">
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div
                class="tab-pane fade"
                id="nav-classrooms"
                role="tabpanel"
                aria-labelledby="nav-classrooms-tab"
              >
                <table class="table table-bordered">
                  <thead class="thead-light xthead-dark">
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Assigned Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="classroom in classrooms" :key="classroom.id">
                      <td>{{ classroom.name }}</td>
                      <td>{{ classroom.enrollment.created_at }}</td>
                    </tr>
                  </tbody>
                  <tbody v-if="!classrooms || !classrooms.length">
                    <tr>
                      <td colspan="5">No data to display</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";

export default {
  layout: AppLayout,
  props: {
    errors: Object,
    tenants: Object,
    roles: Object,
    user: Object,
    classrooms: Object,
  },
  data() {
    return {
      form: {
        roles: this.user.roles.map((role) => role.id),
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        username: this.user.username,
        student_reg_id: this.user.student_reg_id,
        timezone: this.user.timezone,
        email: this.user.email,
        password: "",
        password_confirmation: "",
      },
    };
  },
  methods: {
    update() {
      this.$inertia.patch(route("users.update", this.user.id), this.form);
    },
  },
};
</script>
